import React from "react";
import { TaskForm, Modal, TasksList, TasksManager, Logout } from "../../components";
import { ErrorBoundary } from "../../components/system/ErrorBoundary";
import "./style.scss";

type PropsType = { isModalOpen: boolean };

export const Dashboard: React.FC<PropsType> = ({ isModalOpen }) => {
  return (
    <div className="dashboard-page" style={{ paddingBottom: 24 }}>
      {/* Chaque bloc est isolé : si l’un crash, le reste continue */}
      <ErrorBoundary name="Logout">
        <Logout />
      </ErrorBoundary>

      <ErrorBoundary name="TasksManager">
        <TasksManager />
      </ErrorBoundary>

      <ErrorBoundary name="TasksList">
        <TasksList />
      </ErrorBoundary>

      {isModalOpen && (
        <ErrorBoundary name="TaskForm/Modal">
          <Modal>
            <TaskForm />
          </Modal>
        </ErrorBoundary>
      )}
    </div>
  );
};